import { Divider } from "@material-ui/core";

export type { DividerProps } from "@material-ui/core";

export default Divider;
